import '../scss/main.scss';
// import { register_oembed5k } from './lib/oembed5k.js';
// import { register_form } from './lib/form5k.js';
// import {decryptMailtoAndPhone} from './functions.js';
// import { registerUploadField } from './lib/form5k-upload.js';

// if (process.env.NODE_ENV !== 'production') {
//     import("./dev").then((module) => {

//     })
// }

// window.addEventListener('load', (event) => {
//     //register_form(document);
//     //register_oembed5k(document);
//     decryptMailtoAndPhone();
//     registerUploadField(document);
// });

import { registerMap } from './placefinder.js';
import '../legacy/js/js.js';


function manageWpFormsNewsletterCheckboxes($root = document) {
    document.querySelectorAll(".wpforms-field.wpforms-field-checkbox input[type='checkbox']").forEach(checkbox => {
        checkbox.addEventListener("change", event => {
            if (event.target.checked) {
                const checkbox = $root.querySelector(".wpforms-field.wpforms-field-checkbox input[type='checkbox'][value='1']");
                if (checkbox) {
                    checkbox.checked = true;
                }
            }
            event.target.closest('.wpforms-field-checkbox').querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                console.log('checkbox-loop', checkbox);
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });
        });

    });
}
window.addEventListener('load', (event) => {
    manageWpFormsNewsletterCheckboxes();

    // locations
    const $map_data_wrapper = document.querySelector("#map-data-wrapper");
    if ($map_data_wrapper) {
        const apiKey = $map_data_wrapper.dataset.apiKey;
        const $fridges = document.querySelectorAll('#maps-pins .fridge');
        const store_data = [...$fridges].map(pin => {
            return {
                id: pin.querySelector('.marker-content .circle').dataset.fridgeId,
                title: pin.querySelector('.marker-content p').textContent,
                address: pin.dataset.address,
                lat: parseFloat(pin.dataset.lat),
                lng: parseFloat(pin.dataset.lng),
            };
        });
        console.log('fridges', $fridges);
        console.log('store_data', store_data);
        registerMap({
            apiKey: apiKey,
            $map: document.querySelector(".google-map"),
            $form: document.querySelector("#locations-form"),
            $places: document.querySelector("#places"),
            store_data: store_data,
            labels: {
                'Infos': $map_data_wrapper.dataset.infoButton || 'Infos',
            }
        });
    }
});